import React from 'react'
import { useController } from 'react-hook-form'

import Grid from '@mui/material/Grid'
import { FormControl, FormControlLabel, FormLabel, RadioGroup, makeStyles, Radio as RadioNative, FormHelperText } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    formTitle: {
        fontWeight: "bold",
    }
}));

const Radio = ({
    controllerProps,
    margin = 'normal',
    selectOptions,
    disabled,
    gridProps = {},
    ...props
}) => {
    const { field, fieldState: { error } } = useController({
        defaultValue: "1",
        ...controllerProps,
    })
    const classes = useStyles();
    if (!controllerProps.conditionalFieldCondition) {
        controllerProps.conditionalFieldCondition = []
    }
    let childrenList = [];


    childrenList = selectOptions.map((option) => (
        <FormControlLabel key={option.value} value={option.value} control={<RadioNative color="primary" disabled={option.disabled} />} label={option.label} />
    ))

    const onChange = (event) => {
        field.onChange(event.target.value)
    }

    return (
            <Grid item xs={12} md={6} {...gridProps} style={{ paddingTop: "20px" }}>
                <FormControl component="fieldset" error={error !== undefined} disabled={disabled}>
                    <FormLabel className={classes.formTitle} component="legend" >{props.label}</FormLabel>
                    <RadioGroup
                        row={controllerProps.row}
                        {...props}
                        {...field}
                        value={field.value}
                        onChange={onChange}
                        children={childrenList}
                    />
                </FormControl>
                {(controllerProps.conditionalFieldCondition.indexOf(field.value) >= 0) && controllerProps.conditionalField[controllerProps.conditionalFieldCondition.indexOf(field.value)]}
                {error !== undefined && <FormHelperText style={{ color: "red" }}>{controllerProps.rules.errorMsg}</FormHelperText>}
            </Grid>
    )
}

export default Radio
